//export const api_raiz= "http://localhost:8443/";
export const api_raiz= "https://cctv.skyangel.com.mx:8443/video_back/";
